import {
  Box,
  VStack,
  Heading,
  Text,
  Divider,
  HStack,
  Select,
} from '@chakra-ui/react'
import { withPage } from '@/features/layout'
import { useState } from 'react'
import {
  useUserStats,
  useAvailableWeeks,
  WeekStatOption,
  useBusinessReports,
} from '../../queries/useUserStats'

import Filters from '../../components/AdminUserStatsFilters'
import Summary from '../../components/AdminUserStatsSummary'
import BusinessOverviewTable from '../../components/BusinessOverviewTable'
import StatsTable from '../../components/AdminUserStatsTable'

function AdminUserStatsPage() {
  const [selectedWeek, setSelectedWeek] = useState<WeekStatOption | null>(null)
  const [paymentType, setPaymentType] = useState<string>('all')
  const { data: weeks, isLoading: loadingWeeks } = useAvailableWeeks()
  const { data, isLoading } = useUserStats({
    date: selectedWeek?.value,
    enabled: !!selectedWeek?.value,
  })
  const { data: businessReport, isLoading: loadingBusinessReport } =
    useBusinessReports({ payment_type: paymentType })
  const businessSummary = businessReport?.summary
  const businessMonthly = businessReport?.monthly_revenue_summary

  return (
    <Box maxW="1200px" mx="auto" py={8}>
      <VStack spacing={4} align="stretch">
        <Heading size="lg">User Stats</Heading>
        <Filters
          selectedWeek={selectedWeek}
          setSelectedWeek={setSelectedWeek}
          weeks={weeks || []}
          loadingWeeks={loadingWeeks}
        />

        <Summary
          totalUsers={data?.total_users}
          renewalUsers={data?.renewals}
          renewalsPercentage={data?.renewals_percentage}
          churnUsers={data?.churns}
          churnUsersPercentage={data?.churns_percentage}
          churnButRenew={data?.churn_but_renew}
          churnButRenewPercentage={data?.churn_but_renew_percentage}
        />

        <StatsTable rows={data?.users} isLoading={isLoading} />

        <Text fontSize="sm" color="gray.500">
          * % ของผู้ใช้ คำนวณจาก (จำนวนผู้ใช้ประเภทนั้น ÷ ผู้ใช้ทั้งหมด) × 100
        </Text>

        <Divider />

        <Box pt={6}>
          <VStack spacing={4} align="stretch">
            <HStack justify="space-between">
              <Heading size="lg">Business Overview</Heading>
              <Select
                w="150px"
                value={paymentType}
                onChange={(e) => setPaymentType(e.target.value)}
              >
                <option value="all">All</option>
                <option value="credit_card">Credit Card</option>
                <option value="bank_transfer">Bank Transfer</option>
              </Select>
            </HStack>

            <Summary
              businessFlag={true}
              totalUsers={businessSummary?.total_users}
              newUsers={businessSummary?.new_users}
              newUsersPercentage={businessSummary?.new_users_percentage}
              churnUsers={businessSummary?.churns}
              churnUsersPercentage={businessSummary?.churns_percentage}
              churnButRenew={businessSummary?.churn_but_renew}
              churnButRenewPercentage={
                businessSummary?.churn_but_renew_percentage
              }
              paymentUsers={businessSummary?.payment_users}
              paymentUsersPercentage={businessSummary?.payment_users_percentage}
              creditCardUsers={businessSummary?.credit_cards}
              creditCardUsersPercentage={
                businessSummary?.credit_cards_percentage
              }
              bankTransferUsers={businessSummary?.bank_transfers}
              bankTransferUsersPercentage={
                businessSummary?.bank_transfers_percentage
              }
              yearRevenue={businessSummary?.year_revenue}
              monthRevenue={businessSummary?.month_revenue}
              yearRange={`${businessSummary?.year_range?.from} - ${businessSummary?.year_range?.to}`}
              monthRange={`${businessSummary?.month_range?.from} - ${businessSummary?.month_range?.to}`}
            />

            <BusinessOverviewTable
              rows={businessMonthly}
              isLoading={loadingBusinessReport}
            />

            <Text fontSize="sm" color="gray.500">
              * % ของผู้ใช้ คำนวณจาก (จำนวนผู้ใช้ประเภทนั้น ÷ ผู้ใช้ทั้งหมด) ×
              100
            </Text>
          </VStack>
        </Box>
      </VStack>
    </Box>
  )
}

export default withPage(AdminUserStatsPage)
